module.exports = __webpack_public_path__ + "img/delete.fa09fa6e.svg";